module.exports = __webpack_public_path__ + "src/img/down.2894f4d8.svg";